module.exports = __webpack_public_path__ + "img/img (23).e2c4289c.jpg";